import cookie from "react-cookies";
import * as moment from "moment-timezone";

export const getUserTimezone = (): string => {
    let timezone: string = cookie.load("timezone") as string;

    if (timezone) {
        return timezone;
    }
    else {
        return moment.tz.guess();
    }
};
